// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { changeCustomerFulfillmentMethodStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerFulfillmentMethodSelector";
import { css } from "styled-components";

changeCustomerFulfillmentMethodStyles.pickUpLocation = {
    ...changeCustomerFulfillmentMethodStyles.pickUpLocation,
    wrapper: {
        css: css`
            margin-top: 0;
        `,
    },
    headerText: {
        weight: "bold",
    },
};

changeCustomerFulfillmentMethodStyles.pickupLocationGridItem = {
    width: 12,
    css: css`
        &:empty {
            display: none;
        }
    `,
};

changeCustomerFulfillmentMethodStyles.container = {
    gap: 20,
};

changeCustomerFulfillmentMethodStyles.fulfillmentMethodRadioGroup = {
    css: css`
        display: inline-block;
    `,
};
